const mapStateToProps = (state)=>{
    // const geoObjs = state?.api?.geoObjs;
    // const getGeoObj = state?.service?.Api?.getGeoObj;
    // const selectedGeoObjArray = state?.ui?.selectedGeoObjArray;
    const {

        geozone:{
            geozoneArr,
            geozoneSettingsArr,
        }={},

    } = state;
    return {
        geozoneArr,
        geozoneSettingsArr,
    }
}

export default mapStateToProps